export default {
    cn: {
        salePrimary: {
            commissionSetting: '佣金设定',
            saleResult: {
                title: '销售结果',
                list: [
                    { text: '月结佣金结果', link: '/sale/saleMonthlyResult' }
                ]
            },
            saleResult_v2: {
                title: '销售结果',
                list: [
                    { text: '月结佣金结果', link: '/sale_v2/saleMonthlyResult' }
                ]
            },
            saleReport: {
                title: '销售报表',
                list: [
                    { text: '关系列表报表', link: '/sale/relationshipListReport' },
                    { text: 'MT用户列表', link: '/sale/mtclientReport' },
                    { text: '模板管理', link: '/sale/saleTemplateSetting' },
                ]
            },
            saleReport_v2: {
                title: '销售报表',
                list: [
                    { text: '关系列表报表', link: '/sale_v2/relationshipListReport' },
                    { text: 'MT用户列表', link: '/sale_v2/mtclientReport' },
                    { text: '模板管理', link: '/sale_v2/saleTemplateSetting' },
                ]
            }
        }
    },
    hk: {
        salePrimary: {
            commissionSetting: '佣金設定',
            saleResult: {
                title: '銷售结果',
                list: [
                    { text: '月結佣金結果', link: '/sale/saleMonthlyResult' }
                ]
            },
            saleResult_v2: {
                title: '銷售结果',
                list: [
                    { text: '月結佣金結果', link: '/sale_v2/saleMonthlyResult' }
                ]
            },
            saleReport: {
                title: '銷售报表',
                list: [
                    { text: '關系列表報表', link: '/sale/relationshipListReport' },
                    { text: 'MT用戶列表', link: '/sale/mtclientReport' },
                    { text: '模板管理', link: '/sale/saleTemplateSetting' },
                ]
            },
            saleReport_v2: {
                title: '銷售报表',
                list: [
                    { text: '關系列表報表', link: '/sale_v2/relationshipListReport' },
                    { text: 'MT用戶列表', link: '/sale_v2/mtclientReport' },
                    { text: '模板管理', link: '/sale_v2/saleTemplateSetting' },
                ]
            }
        }
    },
    en: {
        salePrimary: {
            commissionSetting: 'Commission Setting',
            saleResult: {
                title: 'Sale Result',
                list: [
                    { text: 'Sales Monthly Result', link: '/sale/saleMonthlyResult' }
                ]
            },
            saleResult_v2: {
                title: 'Sale Result',
                list: [
                    { text: 'Sales Monthly Result', link: '/sale_v2/saleMonthlyResult' }
                ]
            },
            saleReport: {
                title: 'Sale Report',
                list: [
                    { text: 'Relationship List Report', link: '/sale/relationshipListReport' },
                    { text: 'MT Client List', link: '/sale/mtclientReport' },
                    { text: 'Template Maintenance', link: '/sale/saleTemplateSetting' },
                ]
            },
            saleReport_v2: {
                title: 'Sale Report',
                list: [
                    { text: 'Relationship List Report', link: '/sale_v2/relationshipListReport' },
                    { text: 'MT Client List', link: '/sale_v2/mtclientReport' },
                    { text: 'Template Maintenance', link: '/sale_v2/saleTemplateSetting' },
                ]
            }
        }
    },
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/salePrimary.js